import { BaseDataService } from "../../../services/base/BaseDataService";
import { hasEmbeddedDataImage, withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { WorkflowInstance } from "../models/WorkflowInstance";
import { WorkflowInstanceQuery } from "../models/WorkflowInstanceQuery";

export class WorkflowInstanceService extends BaseDataService<WorkflowInstance, WorkflowInstanceQuery> {
  protected prefixUrl: string = `WorkflowInstances`;

  create(workflowId: number, objectId: number, comment: string){
    if (hasEmbeddedDataImage(comment)) {
      return this.api.post<WorkflowInstance>(`${this.prefixUrl}/Create?workflowId=${workflowId}&objectId=${objectId}`, { data: comment }, withUploadRejectionDetection());
    }
    return this.api.post<WorkflowInstance>(`${this.prefixUrl}/Create?workflowId=${workflowId}&objectId=${objectId}`, { data: comment });
  }

  cancel(workflowId: number, objectId: number, comment: string) {
    if (hasEmbeddedDataImage(comment)) {
      return this.api.post<WorkflowInstance>(`${this.prefixUrl}/Cancel?workflowId=${workflowId}&objectId=${objectId}`, { data: comment }, withUploadRejectionDetection());
    }
    return this.api.post<WorkflowInstance>(`${this.prefixUrl}/Cancel?workflowId=${workflowId}&objectId=${objectId}`, { data: comment });
  }
}
